<template>
  <v-alert
    v-if="alertData"
    :class="alertData.Class"
    :color="alertData.Color"
    :icon="alertData.Icon"
    :prominent="$vuetify.breakpoint.smAndUp"
    :type="alertData.Type"
    border="left"
    class="mb-0"
    dark
    dense
  >
    <v-row align="center">
      <v-col
        :cols="$vuetify.breakpoint.smAndDown ? 'auto' : ''"
        class="grow"
      >
        <div
          v-safe-html="alertData.Title"
          class="text-subtitle-1 font-weight-bold"
        />

        <div
          v-safe-html="alertData.SubTitle"
          class="text-caption"
        />
      </v-col>

      <v-col
        v-if="alertData.Button.Active && !hideActions"
        :class="{'shrink': $vuetify.breakpoint.smAndUp}"
        class="text-right"
      >
        <v-btn
          :block="$vuetify.breakpoint.xs"
          :class="alertData.Button.Class"
          :color="alertData.Button.Color"
          :to="alertData.Button.To"
          depressed
        >
          {{ alertData.Button.Title }}
        </v-btn>
      </v-col>
    </v-row>
  </v-alert>
</template>

<script>

export default {
  name      : 'CurrentPlanWarningAlert',
  components: {},
  directives: {},
  mixins    : [],
  props     : {
    alertData: {
      type   : Object,
      default: undefined
    },
    hideActions: {
      type   : Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
</script>

<style scoped>

</style>
